import { Login } from "react-admin";
import { LoginForm } from "./LoginForm";

export const LoginPage = () => {
  return (
    <Login>
      <LoginForm />
    </Login>
  );
};
